import { createContext } from 'react';

const DisplayContext = createContext();

export default DisplayContext